import React from 'react';
import { withRouter } from 'react-router';
import Qustions from './questionData';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import analyticsContext from '../../components/analytics/Analytics';
import BookingLauncherOnboarding from './BookingLancherOnboarding';
import { bindActionCreators } from 'redux';
import { setOnboardingAnswers } from '../../actions/experiences';
import hackers from '../../resources/onboardig/svg/hackers.svg';
import homeInternet from '../../resources/onboardig/svg/home-internet.svg';
import kidsStroller from '../../resources/onboardig/svg/kids-stroller.svg';
import lockClosed from '../../resources/onboardig/svg/lock-closed.svg';
import mediaEntertainment from '../../resources/onboardig/svg/media-entertainment.svg';
import smartLighting from '../../resources/onboardig/svg/smart-lighting.svg';
import support from '../../resources/onboardig/svg/support.svg';
import wearable from '../../resources/onboardig/svg/wearable.svg';

class Result extends React.Component {
  state = {
    results: [],
  };

  componentDidMount() {
    window.scroll(0, 0);
    let res = [],
      finalArray = [],
      final = [],
      finalArrayChosen = [];

    Qustions.items.map((item) => {
      if (item.answered) {
        item.choices.map((choice) => {
          if (choice.selected) {
            res.push({ key: choice.key, answer: choice.answer });
          }
        });
        finalArray.push({ id: item.key, question: item.question, answers: res });
        res = [];
      }
    });

    finalArray.map((result) => {
      result.answers.map((answer) => {
        if (result.id == 1) {
          if (answer.key == 1 || answer.key == 0) {
            this.dataProcess({ svg: homeInternet, sentence: 'Getting your home internet up to speed' }, final);
          }
        } else if (result.id == 2) {
          if (answer.key == 1) {
            this.dataProcess({ svg: kidsStroller, sentence: 'Setting up parental controls' }, final);
          }
        } else if (result.id == 3) {
          if (answer.key == 1 || answer.key == 0) {
            this.dataProcess({ svg: wearable, sentence: 'Setting up your devices just the way you need them' }, final);
          }
        } else if (result.id == 4) {
          if (answer.key == 1 || answer.key == 0 || answer.key == 2) {
            this.dataProcess(
              { svg: mediaEntertainment, sentence: 'Improving your home entertainment experience' },
              final
            );
          }
        } else if (result.id == 5) {
          if (answer.key == 0) {
            this.dataProcess({ svg: lockClosed, sentence: 'Managing all of your passwords' }, final);
          } else if (answer.key == 1 || answer.key == 2) {
            this.dataProcess({ svg: hackers, sentence: 'Protecting your data online' }, final);
          }
        }
      });
    });

    if (final.length <= 1) {
      final.push({ svg: smartLighting, sentence: 'Getting the right tech for your home' });
      final.push({ svg: support, sentence: 'Answer any questions you may have about the service' });
    } else if (final.length == 2) {
      final.push({ svg: support, sentence: 'Answer any questions you may have about the service' });
    }

    if (final.length > 3) {
      while (finalArrayChosen.length < 3) {
        let i = Math.floor(Math.random() * final.length);
        if (!finalArrayChosen.includes(final[i])) {
          finalArrayChosen.push(final[i]);
        }
      }
    } else {
      finalArrayChosen = final;
    }

    if (!this.props.experiencesList || this.props.onboardingAnswers) {
      this.props.setOnboardingAnswers(finalArray);
    }

    this.setState({
      results: finalArrayChosen,
    });

    analyticsContext
      .withAdvancedProps({
        section: 'onboarding',
      })
      .screenEvent();
  }

  dataProcess = (data, final) => {
    let contains = final.some((elem) => {
      return JSON.stringify(data) === JSON.stringify(elem);
    });
    if (!contains) {
      final.push(data);
    } else if (final.length == 0) {
      final.push(data);
    }
  };

  renderIcons = (answer) => {
    return (
      <div key={answer.sentence} className="resultContainer__descriptionContainer-element">
        <img src={answer.svg} className="resultContainer__descriptionContainer-element-icon" />
        <div className="resultContainer__descriptionContainer-element-description">{answer.sentence}</div>
      </div>
    );
  };

  render() {
    return (
      <div className="resultContainer">
        <div className="resultContainer__title">Thanks! We’ll hand your answers off to a tech expert now.</div>
        <div className="resultContainer__descriptionContainer">
          <div className="resultContainer__descriptionContainer-title">
            Based on what you told us, we can help you with:
          </div>
          {this.state.results.map((answer) => {
            return this.renderIcons(answer);
          })}
        </div>
        <div className="resultContainer__bookingContainer">
          <div className="resultContainer__bookingContainer-title">
            Need help with anything not mentioned here? Let our experts know.
          </div>

          <BookingLauncherOnboarding />

          <div className="resultContainer__bookingContainer-suggestion">
            You can also check out all of the Expert Sessions available to you on our member website
            <Link
              className="resultContainer__bookingContainer-suggestion-link"
              to={this.props.location.pathname.slice(0, 16)}
            >
              here
            </Link>
            .
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state /*, ownProps*/) => ({
  experiencesList:
    state.experiences.experiencesList && state.experiences.experiencesList.version === 2
      ? state.experiences.experiencesList.data
      : null,
  onboardingAnswers: state.experiences.onboardingAnswers,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setOnboardingAnswers,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Result));



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/pages/onboarding/result.js